import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

type SelectedOption = SelectOptionType & {
    mr_group_id: number
}

export const useDropdownBrand = () => {
  const api = useApi()
  const [data, setData] = useState<SelectedOption[]>([])
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    api.get("/assetbrand/")
    .then((res: SuccessFetch<{ payload: { 
            mr_brand_id: number, 
            mr_brand_name: string, 
            mr_group_id: number 
        }[] 
        }>) => {

      setData(res.data.payload.map(item => { 
        return {
             label: item.mr_brand_name, 
             value: item.mr_brand_id.toString(), 
             mr_group_id: item.mr_group_id 
        } }))
    })
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}